"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyUnion = void 0;
const utilityFunctions_1 = require("../../utilities/utilityFunctions");
function applyUnion(factory, overrideKeySelector, src, second) {
    function* generator() {
        const [others, keySelector, equalityComparer] = (0, utilityFunctions_1.getKeySelectorAndComparer)(overrideKeySelector, second);
        if (equalityComparer) {
            const seenKeys = [];
            for (const source of [src, ...others]) {
                for (const item of source) {
                    const key = keySelector(item);
                    let returnItem = true;
                    for (let i = 0; i < seenKeys.length; i++) {
                        if (equalityComparer(key, seenKeys[i])) {
                            returnItem = false;
                            break;
                        }
                    }
                    if (returnItem) {
                        seenKeys.push(key);
                        yield item;
                    }
                }
            }
        }
        else {
            const seenKeys = new Set();
            for (const source of [src, ...others]) {
                for (const item of source) {
                    const key = keySelector(item);
                    if (!seenKeys.has(key)) {
                        seenKeys.add(key);
                        yield item;
                    }
                }
            }
        }
    }
    return factory.createBasicEnumerable(generator);
}
exports.applyUnion = applyUnion;
//# sourceMappingURL=applyUnion.js.map